import { GlobalAxios } from "../axios/axios-config";
import { ITicketAutomationReceivedSlotCalendar } from "../models/ticket_automation_received_slot_calendar";

const TICKET_AUTOMATION_RECEIVED_SLOT_CALENDAR_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/CalendarRegister/CalendarRegister";

export const calendarRegisterList = (params?: any) => {
  return GlobalAxios.get<ITicketAutomationReceivedSlotCalendar[]>(
    TICKET_AUTOMATION_RECEIVED_SLOT_CALENDAR_ROUTE,
    {
      params: params,
      paramsSerializer: {
        indexes: null,
      },
    }
  );
};
